import { FunctionComponent, useState } from "react";
import { useModal } from "@ebay/nice-modal-react";

import { AwsIntegration, AzureIntegration } from "types/generated";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import AttachCloudForm from "components/AttachCloud/Form";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import WarningContextProvider from "components/WarningContext/Provider";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { CLOUD_INTEGRATIONS } from "shared/CloudIntegration/types";
import { AttachCloudEntityType } from "components/AttachCloud/Form/types";
import DrawerForm from "ds/components/DrawerNew/Form";

type ModuleSettingsIntegrationsAttachCloudIntegrationsDrawerProps = {
  cloudConfig: Array<{
    name: string;
    logo: FunctionComponent;
    type: CLOUD_INTEGRATIONS;
  }>;
  filteredAzureIntegrations?: AzureIntegration[];
  filteredAwsIntegrations?: AwsIntegration[];
  hasData: boolean;
  refetch: () => void;
  refetching: boolean;
  moduleId: string;
  onSuccess?: () => void;
  refetchQueries?: string[];
  canAttachGcpIntegration?: boolean;
};

const ModuleSettingsIntegrationsAttachCloudIntegrationsDrawer = createDrawer(
  ({
    moduleId,
    hasData,
    refetch,
    refetching,
    cloudConfig,
    filteredAzureIntegrations,
    filteredAwsIntegrations,
    canAttachGcpIntegration,
  }: ModuleSettingsIntegrationsAttachCloudIntegrationsDrawerProps) => {
    const drawer = useModal();
    const [cloud, setCloud] = useState<CLOUD_INTEGRATIONS>(cloudConfig[0].type);
    const handleClose = () => {
      drawer.hide();
    };

    const [isDirty, setIsDirty] = useState(false);

    return (
      <>
        <WarningContextProvider>
          <DrawerForm blockNavigation isDirty={isDirty} onClose={handleClose}>
            <DrawerHeader justify="between">
              <DrawerHeaderTitle title="Attach cloud integration" />
              <DrawerCloseIcon />
            </DrawerHeader>
            <DrawerBody fullHeight hasStickyFooter>
              <AttachCloudForm
                onDirtyChange={setIsDirty}
                entityId={moduleId}
                entityType={AttachCloudEntityType.Module}
                hasData={hasData}
                refetch={refetch}
                refetching={refetching}
                setCloud={setCloud}
                cloud={cloud}
                cloudConfig={cloudConfig}
                attachableAzureIntegrations={filteredAzureIntegrations}
                attachableAwsIntegrations={filteredAwsIntegrations}
                canAttachGcpIntegration={canAttachGcpIntegration}
                onSuccess={handleClose}
                refetchQueries={[
                  "GetAttachedModuleIntegrations",
                  "GetModuleAttachedGcpIntegration",
                ]}
              />

              <DrawerFooter sticky>
                <DrawerFooterActions>
                  <DrawerCancelButton />
                </DrawerFooterActions>
              </DrawerFooter>
            </DrawerBody>
          </DrawerForm>
        </WarningContextProvider>
      </>
    );
  }
);

export const showModuleSettingsIntegrationsAttachCloudIntegrationsDrawer = createDrawerTrigger(
  ModuleSettingsIntegrationsAttachCloudIntegrationsDrawer
);
